import React, { useState } from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { Textarea } from '~/lib/ui/textarea'
import { Modal } from '~/components/_layouts'
import { useTranslation } from '../../hooks/useTranslation'
import { Button } from '~/lib/ui/button'

const PartOneForm = () => {
  const { interviewParams, setInterviewParams, savedJobs, setDisableContinue } =
    usePracticeInterviewing()
  const [showJobs, setShowJobs] = useState(false)

  const { t } = useTranslation('PartOneForm')

  const handleUpdate = (value, type) => {
    setInterviewParams((prev) => ({ ...prev, [type]: value }))
  }
  return (
    <div className="flex flex-col">
      <h2 className="pb-4">{t('title')}</h2>
      <p className="pb-4">{t('description')}</p>
      <div className="pb-4">
        <Button className="w-1/2" onClick={() => setShowJobs(true)}>
          {t('import')}
        </Button>
      </div>

      <div className="flex w-full flex-col pb-8">
        <label htmlFor="job_title">
          {t('job_title')} ({t('required')})
        </label>
        <input
          id="job_title"
          name="job_title"
          className="rounded-2xl rounded-2xl border-input bg-input-background"
          value={
            interviewParams['job_title'] ? interviewParams['job_title'] : ''
          }
          onChange={(e) => {
            handleUpdate(e.target.value, 'job_title')
            setDisableContinue(e.target.value.length < 1)
          }}
        />
      </div>
      <div className="flex w-full flex-col pb-8">
        <label htmlFor="company">{t('company')}</label>
        <input
          id="company"
          name="company"
          className="rounded-2xl rounded-2xl border-input bg-input-background"
          value={interviewParams['company'] ? interviewParams['company'] : ''}
          onChange={(e) => handleUpdate(e.target.value, 'company')}
        />
      </div>
      <div className="flex w-full flex-col pb-8">
        <label htmlFor="industry">{t('industry')}</label>
        <input
          id="industry"
          name="industry"
          className="rounded-2xl border-input bg-input-background pb-4"
          value={interviewParams['industry'] ? interviewParams['industry'] : ''}
          onChange={(e) => handleUpdate(e.target.value, 'industry')}
        />
      </div>
      <div className="pb-8">
        <label htmlFor="job_description">{t('job_description')}</label>
        <Textarea
          id="job_description"
          className="min-h-[200px]"
          value={
            interviewParams['job_description']
              ? interviewParams['job_description']
              : ''
          }
          onChange={(e) => handleUpdate(e.target.value, 'job_description')}
        />
      </div>
      <Modal
        open={showJobs}
        onClose={() => setShowJobs(false)}
        title={'Create a Interview from My Jobs'}
        description={'Select a job from your saved jobs to create an interview'}
        className="w-full max-w-2xl"
      >
        <div className="flex flex-col gap-2 overflow-scroll">
          {savedJobs?.map((job, idx) => (
            <div
              key={idx}
              className="flex w-full cursor-pointer items-center justify-between gap-4 rounded-2xl border-2 border-solid border-primary p-4"
              onClick={() => {
                handleUpdate(job.title, 'job_title')
                handleUpdate(job.company_name, 'company')
                handleUpdate(job.description, 'job_description')
                setShowJobs(false)
                setDisableContinue(job.title.length < 1)
              }}
            >
              <div>{job.title || 'N/A'}</div>
              <div>{job.company_name || 'N/A'}</div>
              <div>{job.location || 'N/A'}</div>
            </div>
          ))}
          {!savedJobs?.length && (
            <div className="flex w-full items-center justify-center rounded-2xl border-2 border-solid border-primary p-4">
              {"You don't have any saved jobs"}
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default PartOneForm
